import { iRequest } from '@/utils/requestutil';

export async function saveAuth(payload) {
  return iRequest(`/iwms-openapi/api/auth`, {
    method: 'POST',
    body: payload,
  });
}

export async function queryAuth(payload) {
  return iRequest(
    `/iwms-openapi/api/auth/query?companyUuid=${payload.companyUuid}&name=${payload.name}`,
  );
}

export async function modifyAuth(payload) {
  return iRequest(`/iwms-openapi/api/auth/modify`, {
    method: 'POST',
    body: payload,
  });
}

export async function remove(payload) {
  return iRequest(`/iwms-openapi/api/auth/remove?uuid=${payload.uuid}`, {
    method: 'POST',
  });
}

export async function getauth(payload) {
  return iRequest(`/iwms-openapi/api/auth/${payload.uuid}`);
}

export async function getauthType(payload) {
  return iRequest(`/iwms-openapi/api/auth/getType`);
}
